// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6Rd06","title_row":"styles_title_row__24G25","text_content":"styles_text_content__gz1Wr"};